import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));
const franchiseId = Number(localStorage.getItem("franchise_id"));

export const fetchCommissionLedger = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.COMMISSION_LEDGER.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
      // total_count:totalItems
    },
  });
};

export const fetchCommissionLedgerHistory = (
  commission_ledger_id,
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(
    `${EndPoints.COMMISSION_LEDGER.HISTORY_LIST}/${commission_ledger_id}`,
    {
      params: {
        limit,
        page_no,
        ...filter,
      },
    }
  );
};

export const fetchCommissionReportLedger = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.COMMISSION_LEDGER.REPORT_LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
      franchise_id: filter?.franchise_id || franchiseId,
      // total_count:totalItems
    },
  });
};

export const fetchCommissionReportLedgerDashboard = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  console.log("inside dashboard");
  return axiosInstance.get(
    EndPoints.COMMISSION_LEDGER.COMMISSION_LEDGER_CARDS_LIST,
    {
      params: {
        limit,
        page_no,
        zone_id,
        ...filter,
        franchise_id: filter?.franchise_id || franchiseId,
        // total_count:totalItems
      },
    }
  );
};
